import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=744126c6&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SignUp.vue?vue&type=style&index=0&id=744126c6&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "744126c6",
  null
  ,true
)

export default component.exports